import { useEffect, useState, useContext } from 'react';
import { LanguageContext } from '../LanguageContext';
import './ContentDisplay.css'; // Assuming you have a CSS file for styling
import ReactMarkdown from 'react-markdown';

const ContentDisplay = ({ content }) => {
    const [text, setText] = useState("");
    const { language, t } = useContext(LanguageContext);

    useEffect(() => {
        const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
        const textUrl = `${BASE_URL}/text/${content.textBase}-${language}.txt`;

        fetch(textUrl)
            .then((res) => res.text())
            .then(setText)
            .catch((err) => console.error("Failed to load text:", err));
    }, [content.textBase, language]);

    // useEffect(() => {
    //   fetch(content.textUrl)
    //     .then((res) => res.text())
    //     .then((data) => setText(data))
    //     .catch((err) => console.error("Failed to load text:", err));
    // }, [content.textUrl]);

    return (
        <div className="content-display">
            <h1>{content.header}</h1>
            {/* <audio
                key={content.audio} // This forces React to re-render the <audio> tag
                controls
                controlsList="nodownload"
                onContextMenu={(e) => e.preventDefault()}  // disables right-click menu
            >
                <source src={content.audio} />
                Your browser does not support the audio element.
            </audio> */}
            {/* {text.split('\n\n').map((para, idx) => (
                <p key={idx}>{para}</p>
            ))} */}

            <ReactMarkdown>{text}</ReactMarkdown>

        </div>
    );
};

export default ContentDisplay;
